import * as am5 from '@amcharts/amcharts5';

import { getColorv2 } from '../../../../helpers';
import { FONT_FAMILY, FONT_SIZE } from '../../../../theme/layout-size';

export const createLegend = ({
  root,
  chart,
  categories,
  series,
}: {
  root: am5.Root;
  chart: am5.Chart;
  categories: {
    category: any;
    color: am5.Color;
    getShape: (_size: number, _isLegend: boolean) => any;
  }[];
  series: am5.Series[];
  hideLegend?: boolean;
}) => {
  const legend = chart.children.push(
    am5.Legend.new(root, {
      nameField: 'name',
      fillField: 'fill',
      strokeField: 'stroke',
      centerX: am5.percent(50),
      x: am5.percent(50),
      layout: root.gridLayout,
      height: am5.percent(10),
      paddingTop: 20,
      interactive: true,
      interactiveChildren: true,
    })
  );

  // Create custom markers for legend
  legend.markers.template.setAll({
    width: 10,
    height: 10,
    interactive: true,
  });

  // Make legend items interactive
  legend.itemContainers.template.setAll({
    interactive: true,
    interactiveChildren: true,
    cursorOverStyle: 'pointer',
  });

  // Create legend data with custom markers
  const legendData = categories.map((cat, idx) => {
    return {
      name: cat.category as string,
      fill: am5.color(getColorv2(idx)),
    };
  });

  legend.data.setAll(legendData);
  legend.labels.template.setAll({ fontSize: FONT_SIZE.xxs, fontFamily: FONT_FAMILY });

  // Add the custom marker to each legend
  legend.dataItems.forEach((legendDataItem, idx) => {
    const marker = legendDataItem.get('marker');
    const shape = categories[idx].getShape(1, true);
    shape.setAll({
      fill: am5.color(getColorv2(idx)),
      stroke: am5.color('#ffffff'),
      strokeWidth: 1.5,
    });

    marker.children.push(shape);
    legendDataItem.get('markerRectangle').set('forceHidden', true);
  });

  // Add click functionality to each legend item
  legend.dataItems.forEach((dataItem: am5.DataItem<am5.ILegendSettings>) => {
    const container = dataItem.get('itemContainer' as keyof am5.ILegendSettings);
    if (container) {
      container.events.on('click', () => {
        const seriesName = dataItem.get('name' as keyof am5.ILegendSettings);
        const targetSeries = series.find((s) => s.get('name') === seriesName);

        if (targetSeries) {
          const isHidden = targetSeries.get('visible');
          targetSeries.set('visible', !isHidden);

          // Update the container's opacity directly
          container.setAll({
            opacity: isHidden ? 0.3 : 1,
          });
        }
      });
    }
  });

  return legend;
};
